import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const publicApi = axios.create({ baseURL: API });

export const adminApi = (key) =>
  axios.create({
    baseURL: API,
    headers: { "X-Admin-Key": key },
  });

export const BRAND = {
  name: "RRR Paint & Construction LLC",
  tagline: "Great Quality. Great Experience.",
  phone: "334-201-9444",
  phoneHref: "tel:+13342019444",
  email: "rrrpaint334@gmail.com",
  emailHref: "mailto:rrrpaint334@gmail.com",
  area: "Serving Montgomery, AL & surrounding areas",
  website: "www.RRRPaint.com",
  logo:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_dbf6af00-9de5-4596-94b2-78c8ebba44e4/artifacts/s4582968_2.0%20RRR%20PAINT%20LOGO.webp",
};
